<template>
    <div>
        <!-- 登录弹框 start -->
        <el-dialog title="24小时客服热线：400-6565958" :close-on-click-modal=false :close-on-press-escape=false :visible.sync="dialogLogin" width="700px" style="padding: 10px 0;">
            <el-row>
                <el-col :span="10">
                    <div class="login-code textCenter">
                        <img src="../assets/images/login_code.png" alt="" srcset="">
                        <p>扫一扫下载唐宋钢铁APP<br>钢铁行情一手掌握</p>
                    </div>
                </el-col>
                <el-col :span="14">
                    <div class="login-form" style="padding-top: 0;">
                        <el-form :model="loginForm" :rules="loginRules" ref="loginForm">
                            <el-form-item prop="userName">
                                <el-input clearable v-model="loginForm.userName" auto-complete="off" placeholder="请输入手机号/用户名" class="w100"></el-input>
                            </el-form-item>
                            <el-form-item prop="password">
                                <el-input clearable type="password" v-model="loginForm.password" auto-complete="off" placeholder="请输入密码" class="w100"></el-input>
                            </el-form-item>
                            <div class="textRight" style="height: 24px; line-height: 24px;">
                                <a href="javascript:;" class="fontLighter"  @click="goChangePwd">忘记密码</a>
                            </div>
                            <div class="check-code">
                                <span class="inlineBlock vMid">验证码：</span>
                                <div class="code-before textCenter inlineBlock vMid" id="vContainer"></div>
                                <input type="text" class="code-after inlineBlock vMid" v-model="loginForm.verification">
                                <span class="fontRed pointer" @click="changeV">看不清，换一个</span>
                            </div>
                        </el-form>
                        <div slot="footer" class="dialog-footer">
                            <el-button class="bgRed w100 fontWhite" @click="login('loginForm')" size="medium">登 录</el-button>
                            <div class="textCenter">
                                <span class="fontLighter">还没有账号？</span>
                                <a href="javascript:;" class="fontRed"  @click="showRegisterDialog">去注册</a>
                            </div>
                        </div>
                    </div>
                </el-col>
            </el-row>
        </el-dialog>
        <!-- 登录弹框 end -->
        <Register ref="registerDialog"></Register>
    </div>
</template>

<script>
import $ from 'jquery'
import '../assets/js/gVerify'
import { mw_validate, baseUrl } from '../assets/js/common'
import Register from '../templates/registerControl'
export default {
    name: 'Login',
    components: { Register },
    props: {
    },
    data () {
        return {
            dialogLogin: false,
            verifyCode: null,
            loginForm: {
                userName: '',
                password: '',
                verification: '',
                type: 'Y'
            },
            loginRules: {
                userName: [
                    { required: true, message: '请输入手机号/用户名', trigger: 'blur' }
                ],
                password: [
                    { required: true, message: '请输入密码', trigger: 'blur' },
                    { min: 6, max: 16, message: '长度在 6 到 16 个字符', trigger: 'blur' }
                ]
            },
        }
    },
    mounted () {
        // 初始化内容
    },
    methods: {
        init () {
            this.dialogLogin = true;
            setTimeout(() => {
                this.loginForm.verification = '';
                this.verifyCode = new GVerify('vContainer');
            }, 1000)
        },
        changeV () {
            this.verifyCode = new GVerify('vContainer')
        },
        login (formName) {
            const self = this;
            if (!self.verifyCode.validate(self.loginForm.verification)) {
                self.$message({
                    message: '验证码错误',
                    type: 'warning'
                })
                return;
            }
            self.$refs[formName].validate((valid) => {
                if (valid) {
                    self.$post(`${baseUrl.business}/api/user/login`, self.loginForm).then(res => {
                        if (res.status == 200) {
                            self.$cookies.set('token_cyw', res.data.token, '0');
                            self.$message('登录成功');
                            setTimeout(() => {
                                self.$router.go(0);
                            }, 500)
                        } else {
                            self.$message.error(res.msg);
                        }
                    })
                } else {
                    return false;
                }
            });
        },
        goChangePwd () {
            this.dialogLogin = false;
            this.$router.push('/home/changePwd');
        },
        showRegisterDialog () {
            this.$refs.registerDialog.init();
        },
    }
}
</script>

<style scoped>
    .login-code { border-right: 1px solid #f6f6f6; }
    .login-code img { width: 180px; }
    .login-code p { line-height: 26px; }
    .login-form, .top .login-code { padding: 40px; }
    .login-form .check-code { padding: 15px 0; }
    .login-form .check-code .code-before { border: 1px solid #f6f6f6; height: 30px; line-height: 30px; width: 65px; position: relative; }
    .login-form .check-code .code-after { border: 1px solid #ccc; border-radius: 5px; width: 65px; height: 30px; margin-left: 5px; margin-right: 5px;}
    .dialog-footer > div { height: 30px; line-height: 30px; }
</style>